import PropTypes from 'prop-types'
import React, { useRef } from 'react'
import SydLabel from '../../../commonDesign/SydLabel'
import SydSelect from '../../../commonDesign/SydSelect'
import { useFilterSelectContext } from './context'

const FilterTypeSelector = ({
  label,
  description,
  size = 'sm',
  ...selectProps
}) => {
  const { selectedOption, setSelectedOption, options, setSelectedValues } = useFilterSelectContext()
  const anchorEl = useRef(null)

  const onChangeSelectedOption = (value) => {
    setSelectedValues([])
    setSelectedOption(value)
  }
  return (
    <SydLabel label={label} description={description}>
      <div ref={anchorEl} style={{ position: 'relative' }}>
        <SydSelect
          options={options}
          value={selectedOption}
          onChange={(e) => onChangeSelectedOption(e.target.value)}
          size={size}
          {...selectProps}
        />
      </div>
    </SydLabel>
  )
}

FilterTypeSelector.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'sm', 'lg'])
}

// Keep backward compatibility
export default FilterTypeSelector
